import routes from './routes'
import { Fetch } from '../fetch'

class AssignedOrders {
  getAssigned ({ offset, body = {} }) {
    return Fetch('post', routes.getAssigned({ offset }), body)
  }

  updateAssigend (body) {
    return Fetch('put', routes.putAssigned, body)
  }
}

export default new AssignedOrders()
